import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import ParityTooltipsTooltipParityOverviewTable from 'lumen/components/parity/tooltips/tooltip-parity-overview-table';

interface GeneralTablesCellsCellOtaRateSignature {
  Args: {
    issue: unknown;
  };
}

export default class GeneralTablesCellsCellOtaRate extends Component<GeneralTablesCellsCellOtaRateSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get otaRate() {
    // @ts-expect-error: Incorrect type
    return this.hotelAndMarketService.formatRate(this.args.issue);
  }

  <template>
    {{this.otaRate}}
    <ParityTooltipsTooltipParityOverviewTable
      @formattedRate={{this.otaRate}}
      @issue={{@issue}}
      {{! @glint-expect-error: Incorrect type }}
      @message={{@issue.message}}
    />
  </template>
}
